import React, { createContext, useContext, useState, useCallback } from 'react';

const ErrorContext = createContext({});

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within ErrorProvider');
  }
  return context;
};

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [errorId, setErrorId] = useState(0);

  const showError = useCallback((message, duration = 5000) => {
    const id = Date.now();
    setError({ message, id });
    setErrorId(id);

    if (duration > 0) {
      setTimeout(() => {
        clearError();
      }, duration);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const value = {
    error,
    showError,
    clearError
  };

  return (
    <ErrorContext.Provider value={value}>
      {children}
    </ErrorContext.Provider>
  );
};
